import { LinearGradient } from 'expo-linear-gradient'
import { useEffect, useRef } from 'react'
import { Animated, Platform } from 'react-native'
import { DS } from '../../design-system'

const MyFirstGameInterstitial = ({ text, cards = null }: { text: React.ReactNode; cards?: React.ReactNode }) => {
  const opacity = useRef(new Animated.Value(0)).current
  useEffect(() => {
    Animated.timing(opacity, {
      toValue: 1,
      duration: 150,
      useNativeDriver: true
    }).start()
  }, [opacity])

  return (
    <Animated.View style={[{ flex: 1 }, { opacity }]}>
      <LinearGradient
        colors={['#7B043D', '#7B043De6', '#7B043D1a', '#7B043D00']}
        style={[{ flex: 1, paddingTop: 16 }]}
        locations={[0.3, 0.4, 1, 1]}
      >
        <DS.Frame style={{ flex: 1, paddingHorizontal: 16 }}>
          <DS.Frame style={{ gap: 16 }}>{text}</DS.Frame>
          {cards}
        </DS.Frame>
      </LinearGradient>
    </Animated.View>
  )
}

export default MyFirstGameInterstitial
